import {isSpecialKey} from "../utils/browser/is-special-key";

import {cs}       from "./chain-services";
import {UseState} from "./use-state";

export const NumberInputBinding2 = ({onSave, value, onCancel=undefined, getPlaceholder=undefined, next}) => cs(
    ["typing", (_, next) => UseState({next})],
    ({typing}) => {
        const attemptSave = async () => {
            if (typing.value) {
                if (!isNaN(typing.value)) {
                    if (+typing.value !== value) {
                        await onSave(+typing.value);
                    }
                    typing.onChange(null);
                }
            } else if (typing.value === "") {
                typing.onChange(null);

                await onSave(null);
            }
        };

        return next({
            handle: {
                ...typing.value != null ? {
                    value: typing.value,
                } : value == null || value === "" ? {
                    value: "",
                    placeholder: getPlaceholder?.(),
                } : {
                    value: "" + Math.round(value * 100) / 100,
                },

                onChange: (e) => typing.onChange(e.target.value),
                onKeyDown: async (e) => {
                    if (isSpecialKey(e)) {
                        // console.log("Special key");
                    } else if (e.key === "Enter") {
                        e.preventDefault();
                        await attemptSave();
                    } else if (e.key === "Escape") {
                        // console.log("Escape");
                        e.preventDefault();
                        typing.onChange(null);
                        onCancel?.();
                    } else if (e.key?.length > 1) {

                    } else if (isNaN(+e.key) && e.key !== ".") {
                        e.preventDefault();
                    }
                },
                onBlur: attemptSave,
            },
            getValue: () => +typing.value,
            changed: typing.value != null,
            hasError: typing.value && isNaN(typing.value),
        });
    },
);
